import type { ReactNode } from "react";
import { stat } from "@web/theme/theme";
import { MoneyText } from "./MoneyText";

export type StatProps = { label: ReactNode; cents: number; tone?: "default" | "danger" | "accent" };

/** One headline number (Accounting's three numbers). */
export function Stat({ label, cents, tone = "default" }: StatProps) {
  return (
    <div className={stat.card}>
      <span className={stat.label}>{label}</span>
      <MoneyText cents={cents} tone={tone} className={stat.value} />
    </div>
  );
}

/** Content-sized headline cards: wrap whole cards, never split currency values. */
export function StatRow({ children }: { children: ReactNode }) {
  return <div className={stat.row}>{children}</div>;
}
